
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/choose-sim",
      function () {
        return require("private-next-pages/choose-sim/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/choose-sim"])
      });
    }
  